import { useState } from 'react'
import { Center } from '../types'
import { DetailsModal } from './DetailsModal'
import './CenterManagement.css'

interface CenterManagementProps {
  centers: Center[]
  loading?: boolean
  onAddCenter: (name: string) => void
  onDeleteCenter: (centerId: string) => void
  onRefresh?: () => void
}

function CenterManagement({ centers, loading, onAddCenter, onDeleteCenter, onRefresh: _onRefresh }: CenterManagementProps) {
  const [showAddForm, setShowAddForm] = useState(false)
  const [newCenter, setNewCenter] = useState('')
  const [selectedCenter, setSelectedCenter] = useState<Center | null>(null)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleRowClick = (center: Center) => {
    setSelectedCenter(center)
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
    setSelectedCenter(null)
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (!newCenter.trim()) {
      alert('Prosím zadejte název střediska')
      return
    }

    if (centers.some(c => c.name.toLowerCase() === newCenter.trim().toLowerCase())) {
      alert('Toto středisko již existuje')
      return
    }

    onAddCenter(newCenter.trim())
    setNewCenter('')
    setShowAddForm(false)
  }

  return (
    <div className="building-management">
      <div className="management-header">
        <h2>Správa středisek</h2>
        <button 
          className="add-button"
          onClick={() => setShowAddForm(!showAddForm)}
        >
          {showAddForm ? '✕ Zrušit' : '+ Přidat středisko'}
        </button>
      </div>

      {showAddForm && (
        <div className="add-building-form">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="center">Název střediska *</label>
              <input
                type="text"
                id="center"
                value={newCenter}
                onChange={(e) => setNewCenter(e.target.value)}
                placeholder="Např. IT oddělení"
                required
              />
            </div>
            <div className="form-actions">
              <button type="submit" className="submit-button">Přidat</button>
              <button type="button" onClick={() => setShowAddForm(false)} className="cancel-button">
                Zrušit
              </button>
            </div>
          </form>
        </div>
      )}

      {loading ? (
        <div className="loading">Načítání...</div>
      ) : (
        <div className="centers-table-container">
          <table className="centers-table">
            <thead>
              <tr>
                <th>Název střediska</th>
                <th>Akce</th>
              </tr>
            </thead>
            <tbody>
              {centers.length === 0 ? (
                <tr>
                  <td colSpan={2} className="empty-message">
                    Žádná střediska
                  </td>
                </tr>
              ) : (
                centers.map(center => (
                  <tr key={center.id} className="clickable-row" onClick={() => handleRowClick(center)}>
                    <td><strong>{center.name}</strong></td>
                    <td>
                      <button
                        className="delete-button"
                        onClick={(e) => {
                          e.stopPropagation()
                          onDeleteCenter(center.id)
                        }}
                        title="Odstranit středisko"
                      >
                        🗑️
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Модальное окно с детaлями */}
      {selectedCenter && (
        <DetailsModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          title={`Středisko: ${selectedCenter.name}`}
          actions={
            <button
              className="delete-button"
              onClick={() => {
                if (confirm(`Opravdu chcete smazat středisko ${selectedCenter.name}?`)) {
                  onDeleteCenter(selectedCenter.id)
                  handleCloseModal()
                }
              }}
              style={{
                background: '#dc3545',
                color: 'white',
                border: 'none',
                padding: '0.5rem 1rem',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              🗑️ Smazat středisko
            </button>
          }
        >
          <div className="details-section">
            <div className="details-grid">
              <div className="details-item">
                <div className="details-label">Název střediska</div>
                <div className="details-value"><strong>{selectedCenter.name}</strong></div>
              </div>
              <div className="details-item">
                <div className="details-label">ID</div>
                <div className="details-value">{selectedCenter.id}</div>
              </div>
            </div>
          </div>
        </DetailsModal>
      )}
    </div>
  )
}

export default CenterManagement

